const alertConfiguration = { hideProgressBar: true }

export default alertConfiguration;